import { ServiceHistory } from "./components/serviceHistory";
import { ServiceBookingStepper } from "./components/ServiceBookingStepper";
import { BookingStepOne } from "./components/BookingStepOne";
import { BookingStepTwo } from "./components/BookingStepTwo";
import { BookingStepThree } from "./components/BookingStepThree";
import { BookingStepFour } from "./components/BookingStepFour";
import { useBookingFlow } from "../../hooks/useBookingFlow";
import { ServiceSlider } from "./components/ServiceSlider";
import { ServiceBookingStepHeader } from "./components/ServiceBookingStepHeader";
import { BookingSummary } from "./components/BookingSummary";
import { useServiceCarStore } from "../../store/serviceCarStore";
import { useLocation, useParams, useSearchParams } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { useGetShowSummary } from "../../hooks/react-query/useNewService";
import { BookingStepFive } from "./components/BookingStepFive";

export const NewServicePage = () => {
  // LOCAL STATE:
  const { state, dispatch } = useBookingFlow();
  const { carInfo } = useServiceCarStore();
  const isTesla = carInfo?.MakeName === "Tesla"
  const [ isAfterViva, setIsAfterViva ] = useState(false)

  // DATA:

  // FETCH DATA:

  // LOCAL VARIABLES:
  const location = useLocation();
  const [searchParams] = useSearchParams();

  const isSummaryPage = location.pathname.startsWith('/service-booking/summary');
  const { flowId } = useParams();
  const paymentStatus = searchParams.get('paymentStatus');

  const resolvedFlowId = React.useMemo(
  () => flowId ?? state?.serviceFlowId,
  [flowId, state?.serviceFlowId]
);
  
  const isSummaryReady = state?.step === 6 && !!resolvedFlowId;

  const { data } = useGetShowSummary({ serviceFlowId: resolvedFlowId, enabled: isSummaryReady, });

  // USE EFFECTS:
  useEffect(()=>{
    dispatch({ type: "SET_SUMMARY", appointmentSummary: data });
  },[data, dispatch])

  useEffect(()=>{
    dispatch({ type: "SET_ISTESLA", isTesla: carInfo?.MakeName === "Tesla" });
  },[carInfo, dispatch])

  useEffect(()=>{
    if(isSummaryPage) {
      setIsAfterViva(true)
      dispatch({ type: "SET_STEP", step: 6 });
    }
  },[searchParams, isSummaryPage, dispatch])

  // HANDLERS & FUNCTIONS

  const renderStepComponent = () => {
    switch (state.step) {
      case 1:
        return <BookingStepOne state={state} dispatch={dispatch} isTesla = {isTesla}/>;
      case 2:
        return <BookingStepTwo state={state} dispatch={dispatch} />;
      case 3:
        return <BookingStepThree state={state} dispatch={dispatch} />;
      case 4:
        return (state?.isAuthorizedEV 
      // && !state?.serviceLightIndicator
      && state?.options?.standarizedService === true 
      && state?.options?.bodyWork === false 
      && state?.options?.tyresChange === false) ? <BookingStepFive state={state} dispatch={dispatch} /> : <BookingStepFour state={state} dispatch={dispatch} />;
      case 5:
        return <BookingStepFive state={state} dispatch={dispatch} />;
      case 6: 
        return <BookingSummary state={state} dispatch={dispatch} afterViva={isAfterViva} paymentStatus={paymentStatus}/>;
      default:
        return null;
    }
  };

  return (
    <>
      <div
        className={`flex flex-col max-h-screen w-full`}
      >
        {state.step !== 6 &&
          (state.step > 0 && (
            !(state.step === 1 && isTesla) && (
              <ServiceBookingStepper state={state} dispatch={dispatch} />
            )
          ))}

        <div className={`flex flex-row max-h-screen ${(state?.step===0) ? "min-h-[92vh]" : "min-h-[83vh]"} w-full ${(state?.step === 6) && 'justify-center'} ${(isTesla) && "pt-10"} ${(state?.step===0) && "pt-2"} max-sm:pb-5`}>
          {state?.step < 6 && <ServiceSlider isTesla = {isTesla} state={state} dispatch={dispatch} />}
          <div className={`flex flex-row w-full justify-center align-middle  max-lg:px-5 lg:-ml-7`}>
            {state.step === 0 ? (
              <div className="gap-5 flex max-lg:flex-col justify-start container pt-10">
                <ServiceHistory
                  state={state}
                  dispatch={dispatch}
                />
              </div>
            ) : (
              <div className='w-full flex flex-col max-h-full justify-start items-center'>
                <>
                  {state?.step < 6 && (state.step !== 1 || !isTesla) && <ServiceBookingStepHeader state={state} dispatch={dispatch} />}
                  <div className={`flex justify-center items-center max-w-[55vw] min-w-[55vw] max-lg:min-w-full max-xl:min-w-[652px] pb-5`}>
                    {renderStepComponent()}
                  </div>
                </>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
